import React from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <Container className="text-center mt-5">
      <Alert variant="danger">
        <Alert.Heading>Không có quyền truy cập</Alert.Heading>
        <p>Bạn không có quyền truy cập vào trang này. Vui lòng liên hệ quản trị viên nếu bạn tin rằng đây là lỗi.</p>
      </Alert>
      <Button variant="primary" onClick={() => navigate('/students')}>
        Quay lại Trang chủ
      </Button>
    </Container>
  );
};

export default UnauthorizedPage;
